export const adminLoginResponse = {
  token:
    "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJkYXRhIjp7ImF1dGhJZCI6IjZlMjZhNDhlLThmOTctNGQ3Ni1iZTM2LTg5MzAxMTIxODA5OCIsInJvbGUiOiJhZG1pbiIsInVzZXJJZCI6Ijc3NzE5NWM1LTZiZDctNDg1NC1hODI3LWJlZjRkMTk5ODQ2OCJ9LCJleHAiOjE2ODc0Mzg1OTd9.39yJG9bRgDEPgZ7uDpNrRrXNGSXN8quq1HxtNx7Riik",
  userId: "777195c5-6bd7-4854-a827-bef4d1998468",
  authId: "6e26a48e-8f97-4d76-be36-893011218098",
  role: "admin"
};
